import React from 'react'
import ControlledAutocompleteTransfixUser from 'transfix-form/components/ControlledAutocompleteTransfixUser'
import Grid from 'transfix-ui/core/Grid'
import { ControlledAutocompleteTransfixMultiUser } from 'apps/marketplace/components/ControlledAutocompleteTransfixMultiUser'
import { useUserDetails } from 'utils/hooks'
import { CarrierRelationshipsModalFormGroup } from './CarrierRelationshipsModalFormGroup'
import { TEST_IDS, AUTOCOMPLETE_TRANSFIX_USER_PLACEHOLDER } from './constants'
import { getErrorMessage } from './helpers/getErrorMessage'
import { useCarrierRelationshipsModalFormContext } from './hooks/useCarrierRelationshipsModalForm'

export const CarrierRelationshipsModalForm = () => {
  const { control, errors } = useCarrierRelationshipsModalFormContext()
  const { userPermissions } = useUserDetails()
  const canEditPcmOrCeReps = userPermissions?.canUpdatePcm
  const canEditCeRep = userPermissions?.canEditCarrierCeRep

  return (
    <form data-test={TEST_IDS.form}>
      <Grid container direction='column' spacing={3}>
        <CarrierRelationshipsModalFormGroup
          label='Carrier Manager'
          primaryField={
            <ControlledAutocompleteTransfixUser
              control={control}
              name='primaryManager'
              AutocompleteTransfixUserProps={{
                label: 'Primary Carrier Manager',
                disabled: !canEditPcmOrCeReps,
                inputValidationMessage: getErrorMessage(errors, 'primaryManager'),
                placeholder: AUTOCOMPLETE_TRANSFIX_USER_PLACEHOLDER,
                dataTest: TEST_IDS.primaryManager,
              }}
            />
          }
          secondaryField={
            <ControlledAutocompleteTransfixMultiUser
              control={control}
              label='Secondary Carrier Manager'
              name='secondaryManagers'
              placeholder={AUTOCOMPLETE_TRANSFIX_USER_PLACEHOLDER}
            />
          }
        />

        <CarrierRelationshipsModalFormGroup
          label='CE Manager'
          primaryField={
            <ControlledAutocompleteTransfixUser
              control={control}
              name='primaryExperienceRep'
              AutocompleteTransfixUserProps={{
                label: 'Primary CE Manager',
                disabled: !canEditCeRep,
                inputValidationMessage: getErrorMessage(errors, 'primaryExperienceRep'),
                placeholder: AUTOCOMPLETE_TRANSFIX_USER_PLACEHOLDER,
                dataTest: TEST_IDS.primaryExperienceRep,
              }}
            />
          }
          secondaryField={
            <ControlledAutocompleteTransfixUser
              control={control}
              name='secondaryExperienceRep'
              AutocompleteTransfixUserProps={{
                label: 'Secondary CE Manager',
                disabled: !canEditCeRep,
                inputValidationMessage: getErrorMessage(errors, 'secondaryExperienceRep'),
                placeholder: AUTOCOMPLETE_TRANSFIX_USER_PLACEHOLDER,
                dataTest: TEST_IDS.secondaryExperienceRep,
              }}
            />
          }
        />

        <CarrierRelationshipsModalFormGroup
          label='Carrier Sales Manager'
          primaryField={
            <ControlledAutocompleteTransfixUser
              control={control}
              name='primarySalesRep'
              AutocompleteTransfixUserProps={{
                disabled: !canEditPcmOrCeReps,
                label: 'Primary Carrier Sales Manager',
                inputValidationMessage: getErrorMessage(errors, 'primarySalesRep'),
                placeholder: AUTOCOMPLETE_TRANSFIX_USER_PLACEHOLDER,
                dataTest: TEST_IDS.primaryExperienceRep,
              }}
            />
          }
          secondaryField={
            <ControlledAutocompleteTransfixMultiUser
              control={control}
              disabled={!canEditPcmOrCeReps}
              label='Secondary Carrier Sales Manager'
              name='secondarySalesReps'
              placeholder={AUTOCOMPLETE_TRANSFIX_USER_PLACEHOLDER}
            />
          }
        />
      </Grid>
    </form>
  )
}
